import { StringIndexedDict } from "../../../../api/GenericTypes";
import {
  GenericEntityVirtualizedEntitySelectFormFieldProps,
  GenericVirtualizedEntitySelectFormFieldControllerWrapper,
} from "../../../formfields/GenericVirtualizedSelectFormField/GenericVirtualizedEntitySelectFormFieldControllerWrapper";
// import { QuickAddWrapper } from "../../QuickAdd/common/QuickAddWrapper";
import {
  DataFormatFilters,
  DataFormatSortingOptionsConsts,
  DataFormatSuggestions,
  dataFormatsConstants,
} from "../../../../api/DataFormats";

export const DataFormatsVirtualizedSelectForm = <Entity extends StringIndexedDict>(
  props: GenericEntityVirtualizedEntitySelectFormFieldProps<Entity, DataFormatSuggestions, DataFormatFilters>
) => {
  return (
    <GenericVirtualizedEntitySelectFormFieldControllerWrapper<Entity, DataFormatSuggestions, DataFormatFilters>
      {...props}
      filters={{ sortBy: [{ property: "NAME", sortDirection: "ASC" }], excludeIds: ["doc_multi"], ...props.filters }}
      //   onRowRenderer={(item) => <></>}
      entityConstants={dataFormatsConstants}
      orderByOptions={DataFormatSortingOptionsConsts}
      allowCreateEntity={false}
    />
  );
};
